module.exports = __webpack_public_path__ + "img/ar.8888762.png";